import { create } from 'zustand'

const decodeJwtPayload = (token) => {
  try {
    return JSON.parse(atob(token.split('.')[1]));
  } catch {
    return {};
  }
};

const storedToken = localStorage.getItem('access_token');
const storedPayload = storedToken ? decodeJwtPayload(storedToken) : {};

// Balanced Habits State
const bhs = create((set) => ({
  // Sign In State
  signedIn: !!storedToken,
  accessToken: storedToken || null,
  userRole: storedPayload.role || null,
  requirePasswordChange: storedPayload.requirePasswordChange || false,
  userSignedIn: (token) => {
    localStorage.setItem('access_token', token);
    const { role, requirePasswordChange } = decodeJwtPayload(token);
    set({ signedIn: true, accessToken: token, userRole: role || null, requirePasswordChange: requirePasswordChange || false });
  },
  userSignedOut: () => {
    localStorage.removeItem('access_token');
    set({ signedIn: false, accessToken: null, userRole: null });
  },

  // User Data
  userData: {username: ''},

  // Selected Location
  selectedLocation: '',
  setSelectedLocation: (location) => set({ selectedLocation: location }),
}));

export default bhs;
